/**
 * @module ArticlesList
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Название компонента.
 */
export default class ArticlesList extends Component {
    static className = 'articles-list';
}
